<template>
  <div class="pro-pic inner-upload-single">
    <transition-group tag="div" class="drag-wrap">
      <div
        class="drag-item"
        v-for="(file, index) in fileListNew"
        :key="file.url"
        draggable="true"
        @dragstart="handleDragStart($event, file)"
        @dragover.prevent="handleDragOver($event, file)"
        @dragenter="handleDragEnter($event, file)"
        @dragend="handleDragEnd($event, file)"
      >
        <div class="file-box" :class="{ borderColorChange: file.url }">
          <div v-if="file.url" @click="getModleShow(index)" style="cursor: pointer" class="file-boxText">
            <!-- <div v-if="file.url"> -->
            {{ file.name }}
          </div>
          <div
            v-if="file.url && !dragging"
            class="file-cover-wrap"
            @click.stop="del(index)"
          >
            删除
          </div>
        </div>
      </div>
    </transition-group>
    <el-upload
      class="avatar-uploader"
      action="/service-center/upload/file/single"
      :headers="headers"
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :on-success="handleAvatarSuccess"
      :on-progress="handleAvatarProgress"
      :limit="limit"
      :disabled="disabledBtn"
      v-if="(fileListNew.length != limit)"
    >
      <el-button>{{ buttonName }}</el-button>
    </el-upload>
    <three-d
      ref="threeBox"
      :innerVisible="innerVisible"
      :fileListNew="fileListNew"
      @closeDlog="closeDlog"
    ></three-d>
  </div>
</template>

<script>
import threeD from "../threeD/index";
export default {
  name: "uploadMultiImage",
  components: {
    threeD,
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    buttonName: {
      type: String,
      default: "点击上传",
    },
    limit: {
      type: Number,
      default: 9999,
    },
    fileType: {
      type: String,
      default: "",
    },
    fileTypeMessage: {
      type: String,
      default: "",
    },
    modelBtn: {
      type: Boolean
    },
  },
  data() {
    return {
      dragging: null,
      disabledBtn: false,
      fileListNew: [],
      beforeFileList: [],
      headers: {
        Authorization:
          "Bearer " + this.$cookies.get("api_access_token"),
      },
      innerVisible: false,
    };
  },
  watch: {
    fileList: {
      handler(val) {
        if (val) {
          this.fileListNew = val;
        } else {
          this.fileListNew = [];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  computed: {},
  methods: {
    closeDlog(index) {
      this.innerVisible = index;
    },
    handleAvatarSuccess(res, file) {
      this.disabledBtn = false;
      this.fileListNew.push(res);
      this.$emit("fileListChange", this.fileListNew);
    },

    beforeAvatarUpload(file) {
        this.disabledBtn = true;
      if (this.fileType) {
        let fileName = file.name.lastIndexOf(".") + 1;
        const fileNameLen = file.name.length;
        const fileTypeName = file.name.substring(fileName, fileNameLen);
        if (this.fileType.indexOf(fileTypeName) === -1) {
          this.$message.warning(this.fileTypeMessage);
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }

    },
    handleAvatarProgress(event) {},
    del(index) {
      this.fileListNew.splice(index, 1);
      this.$emit("deleteFile", this.fileListNew);
    },
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move";
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      console.log('999', );
      const newItems = [...this.fileListNew];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.fileListNew = newItems;
      this.$emit("getDragFile", newItems);
    },
    // 3D弹窗
    getModleShow(index) {
      this.$refs.threeBox.threeAnimal(index);
      this.innerVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
button {
  width: 100px;
  background: #3d7fff;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  color: #ffffff;
}
.container {
  width: 80px;
  height: 300px;
  position: absolute;
  left: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
}
.item {
  margin-top: 10px;
  transition: all linear 0.3s;
}
.drag-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .drag-item {
    margin-bottom: 13px;
    width: 49%;
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.avatar-uploader-icon {
  color: #409eff;
  width: 275px;
  height: 200px;
  text-align: center;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
  font-size: 12px;
  border: 1px dashed #ddd;
}
.file-box {
  width: 100%;
  height: 100%;
  float: left;
  margin-right: 13px;
  position: relative;
  .file-boxText {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 240px;
  }
}

.file-box:last-child {
  margin-right: 0;
}

.el-icon-plus:before {
  content: "";
}

// 删除
.file-cover-wrap {
  right: 0;
  top: 0;
  position: absolute;
  line-height: 55px;
  color: #3d7fff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/uploadFile/index.vue